var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"good-shop",on:{"click":function($event){$event.stopPropagation();return _vm.gotoShop($event)}}},[(_vm.popShortName)?_c('span',{class:[
      'shop-name',
      {
        'shop-name-tip': !_vm.showTip
      }
    ]},[_vm._v(" "+_vm._s(_vm.popShortName)+" ")]):_vm._e(),(_vm.showTip && _vm.popShortName)?_c('span',{staticClass:"shop-tip"},[_vm._v("进店")]):_vm._e(),(_vm.popShortName)?_c('IconFont',{attrs:{"name":"mc-icon-arrowright","size":"6px"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }